"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const FileReviewPopupErrors_1 = __importDefault(require("@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewStepPopup/FileReviewPopupErrors"));
const FileReviewPopupSuccess_1 = __importDefault(require("@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewStepPopup/FileReviewPopupSuccess"));
const FileReviewStepPopup = (props) => {
    const { uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { numComplete, numErrors } = props;
    return (react_1.default.createElement(Popup_1.default, { showClose: false, onClose: () => uiStore.setBulkUploadModalIsOpen(false) },
        react_1.default.createElement("div", { className: 'status-overview' },
            numErrors ? (react_1.default.createElement(FileReviewPopupErrors_1.default, { numComplete: numComplete, numErrors: numErrors })) : (react_1.default.createElement(FileReviewPopupSuccess_1.default, { numComplete: numComplete })),
            react_1.default.createElement("div", { className: "search-confirm-popup-content" },
                react_1.default.createElement("div", { className: 'buttons-block' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward, onClick: () => uiStore.setBulkUploadModalIsOpen(false) }, "Continue"))))));
};
exports.default = (0, mobx_react_1.observer)(FileReviewStepPopup);
